import { CustomerSettingsMessage } from '../../../../types/CustomerSettingsMessage';
import { Callout } from '../../../cdl/Callout/Callout';
import { Switch } from '../../../cdl/Switch/Switch';
import { translate } from '../../../common/helpers/translate.helper';
import { IconInfoCircle } from '../../../common/icons/cdl/InfoCircle';
import { Box } from '../../../common/ui/Box';
import { useCustomerSettingsOptimisticMutation } from '../../hooks/useCustomerSettingsOptimisticMutation';

interface CustomerNotificationSettingsProps {
    customerSettings: CustomerSettingsMessage;
    customerId: string;
}

export const CustomerNotificationSettings = ({ customerSettings, customerId }: CustomerNotificationSettingsProps) => {
    const editCustomerSettingsMutation = useCustomerSettingsOptimisticMutation(customerId);

    const updateEmailSettings = (newSettings: Partial<CustomerSettingsMessage['emailCategorySettings']>) => {
        // @ts-ignore
        editCustomerSettingsMutation.mutate({
            id: customerId,
            settings: {
                ...customerSettings,
                emailCategorySettings: {
                    ...customerSettings.emailCategorySettings,
                    ...newSettings,
                },
            },
        });
    };

    const emailCategorySettings = customerSettings.emailCategorySettings;

    return (
        <Box display="flex" flexDirection="column" gap={24}>
            <Callout
                description={translate('company.notificationSettings.emailNotificationSettingsHint')}
                Icon={IconInfoCircle}
            />

            <Switch
                checked={emailCategorySettings.offerStateChange}
                onChange={(checked) =>
                    updateEmailSettings({
                        offerStateChange: checked,
                    })
                }
                label={translate('company.notificationSettings.statusUpdate')}
                description={translate('company.notificationSettings.statusUpdateDescription')}
            />
            <Switch
                checked={emailCategorySettings.offerUpdate}
                onChange={(checked) =>
                    updateEmailSettings({
                        offerUpdate: checked,
                    })
                }
                label={translate('company.notificationSettings.newDetails')}
                description={translate('company.notificationSettings.newDetailsDescription')}
            />
            <Switch
                checked={emailCategorySettings.newChatMessage}
                onChange={(checked) =>
                    updateEmailSettings({
                        newChatMessage: checked,
                    })
                }
                label={translate('company.notificationSettings.newChatMessages')}
            />
            <Switch
                checked={emailCategorySettings.stockWarningLevelReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        stockWarningLevelReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.stockWarningLevelReminder')}
                description={translate('company.notificationSettings.stockWarningLevelReminderDescription')}
            />
            <Switch
                checked={emailCategorySettings.safetyReserveLevelReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        safetyReserveLevelReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.safetyReserveLevel')}
                description={translate('company.notificationSettings.safetyReserveLevelDescription')}
            />
            <Switch
                checked={emailCategorySettings.keyPortCallReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        keyPortCallReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.keyPortCallReminder')}
                description={translate('company.notificationSettings.keyPortCallReminderDescription')}
            />
            <Switch
                checked={emailCategorySettings.orderDeliveryReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        orderDeliveryReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.orderDeliveryReminder')}
                description={translate('company.notificationSettings.orderDeliveryReminderDescription')}
            />
            <Switch
                checked={emailCategorySettings.openEnquiryReminder}
                onChange={(checked) =>
                    updateEmailSettings({
                        openEnquiryReminder: checked,
                    })
                }
                label={translate('company.notificationSettings.openEnquiryReminder')}
                description={translate('company.notificationSettings.openEnquiryReminderDescription')}
            />
        </Box>
    );
};
